import { type QueryClient, useSuspenseQuery } from "@tanstack/react-query";
import { ensureAPIQueryData } from "lib/query/api-queries";
import { trpc } from "lib/trpc";
import { useCurrentApplication } from "routes/_blacklight/_app-shell/-use-current-application";

export function useGenerations() {
    const currentApp = useCurrentApplication();
    return useSuspenseQuery(
        trpc.generations.list.queryOptions(
            { applicationId: currentApp.id },
            {
                refetchInterval: (query) => {
                    const data = query.state.data;
                    if (data == null) return false;
                    const hasActive = data.some(
                        (g) => g.status === "queued" || g.status === "pending" || g.status === "running",
                    );
                    return hasActive ? 5000 : false;
                },
            },
        ),
    );
}

export function useGenerationDetail(generationId: string) {
    return useSuspenseQuery({
        ...trpc.generations.detail.queryOptions({ generationId }),
        refetchInterval: (query) => {
            const data = query.state.data;
            if (data == null) return false;
            const isActive = data.status === "queued" || data.status === "pending" || data.status === "running";
            return isActive ? 5000 : false;
        },
    });
}

export async function ensureGenerationsListData(queryClient: QueryClient, applicationId: string) {
    await ensureAPIQueryData(queryClient, trpc.generations.list.queryOptions({ applicationId }));
}

export async function ensureGenerationDetailData(queryClient: QueryClient, generationId: string) {
    await ensureAPIQueryData(queryClient, trpc.generations.detail.queryOptions({ generationId }));
}
